export default __webpack_public_path__ + "static/media/Calendar.5efe8b68.svg";